import { render, staticRenderFns } from "./FieldEditDialog.vue?vue&type=template&id=5b479958&scoped=true"
import script from "./FieldEditDialog.vue?vue&type=script&lang=js"
export * from "./FieldEditDialog.vue?vue&type=script&lang=js"
import style0 from "./FieldEditDialog.vue?vue&type=style&index=0&id=5b479958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b479958",
  null
  
)

export default component.exports